export default __webpack_public_path__ + "static/media/nutzungsbedingungeninterb2bike.ecf3aa27.pdf";